<template>
	<div v-if="user" class="btn-toolbar pull-left" role="toolbar">
		<div class="btn-group form-inline" role="group" aria-label="...">
			<input type="checkbox" v-model="filter.allowDate">
			<input
				:class="{ disabled: !filter.allowDate }"
				id="daterange"
				type="text"
				class="form-control"/>
		</div>

		<div v-if="projects" class="btn-group" role="group" aria-label="...">
			<select v-if="projects.length" v-model="filter.project_id" class="form-control">
				<option :value="null">Proyecto...</option>
				<option v-for="project in projects" :value="project.id">
					{{project.name}}
				</option>
			</select>
		</div>

		<div v-if="user.hasRole(['manager', 'admin'])" class="btn-group" role="group" aria-label="...">
			<select v-if="users" v-model="filter.user_id" class="form-control">
				<option :value="null">Personal...</option>
				<option v-if="users.length" v-for="user_filter in users" :value="user_filter.id">{{user_filter.email}}</option>
			</select>
		</div>

		<div class="btn-group" role="group" aria-label="...">
			<input @keyup.enter="doFilter()" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
		</div>

		<div class="btn-group" role="group" aria-label="...">
			<button
				title="Filtrar"
				ref="btnfilter"
				@click="doFilter()"
				data-style="slide-left"
				class="btn btn-success">
				<i class="fa fa-search" aria-hidden="true"></i>
			</button>
			<button
				title="Restablecer"
				ref="btnreset"
				@click="reset()"
				data-style="slide-left"
				class="btn btn-default">
				<i class="fa fa-refresh" aria-hidden="true"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'filter'],
		components: {

		},
		data () {
			return {
				projects: null,
				users: null,
			}
		},
		mounted() {
			this.initDate()
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getProjects()
				if(this.user.hasRole(['manager', 'admin'])) {
					this.getUsers()
				}
			},
			doFilter() {
				this.filter.text = this.filter.text.trimStart()
				if(this.filter.allowDate) {
					this.filter.date = $('#daterange').val()
				} else {
					this.filter.date = null
				}
				this.$emit('filterSet');
			},
			reset() {
				this.initDate()
				this.$emit('filterReset')
			},
			getProjects() {
				this.$http.get('admin/projects/projects')
				.then(response => {
					this.projects = response.body
				})
			},
			getUsers() {
				this.$http.get('admin/users')
				.then(response => {
					this.users = response.body
				})
			},
			initDate() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/FilterBar.vue